import $ from 'jquery';

$(document).ready(function () {
    // Search By Letter
    let click_first_char;
    var s_l = sessionStorage.getItem('selected_letter');
    var url_params = new URLSearchParams(window.location.search);
    var search_param = url_params.toString();
    var url_validation = search_param.split('=');

    //Clears previous selected letter from session storage. This is to prevent a case where someone clicks 100 different letters and doesnt close their browser. It would then store each letter in local memory
    if (sessionStorage.getItem("selected_letter") != null) {
        sessionStorage.clear();
    }

    // Click A-Z menu item
    $('.sbl li.active').click(function () {
        $('#main-area .sbl_results article').removeClass('show');
        click_first_char = $(this).data('letter');
        
        // Stores the newly selected Letter in the session memory to have a class applied once the document is ready.
        sessionStorage.setItem('selected_letter', click_first_char);

        if (click_first_char == '#') {
            click_first_char = 1;
        }
        let currentUrl = window.location.pathname.split('/');
        window.location = `${window.location.hostname}/${currentUrl[1]}?startsWith=${click_first_char}`;

    });

    if(s_l == url_validation[1]){
        $('.sbl li.active[data-letter="' + s_l + '"]').addClass('rt_selected');
    }
});
